import { FETCH_ANWALT } from "../actions/type";

const initState = {
  empty: true
};

export default function(state = initState, action) {
  switch (action.type) {
    case FETCH_ANWALT:
      return action.data;
    default:
      return state;
  }
}
